import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { getTheme } from '../../theme'
import { useRef, useEffect, ReactElement } from 'react'
import Scatterplot from 'components/Scatterplot'
import TreeScroll from 'components/TreeScroll'
import useScrollStore from '../useScrollStore'
import { Leva } from 'leva'
import PlantsCalendar from 'components/PlantsCalendar'
import SpringIndexPlotScroll from 'components/SpringIndexPlotScroll'
import SpeciesComparison from 'components/SpeciesComparison'

const modules: { [key: string]: ReactElement } = {
  intro: <TreeScroll />,
  scatterplot: <Scatterplot />,
  calendar: <PlantsCalendar />,
  springIndex: <SpringIndexPlotScroll />,
  species: <SpeciesComparison />,
}

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const theme = getTheme(colorMode, tenant)
  const debugRef = useRef<HTMLDivElement>(null)

  useEffect(
    () =>
      useScrollStore.subscribe((state) => {
        if (debugRef.current) {
          debugRef.current.innerHTML = `Stage ${
            state.scrollStage
          } (${state.scrollStagePct.toFixed(2)}%) ${state.scrollPct.toFixed(2)}`
        }
      }),
    []
  )

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>
        {/*process.env.NODE_ENV === 'production' && <Leva hidden />*/}
        <Leva hidden />
        {process.env.NODE_ENV !== 'production' && (
          <div
            ref={debugRef}
            style={{ position: 'fixed', top: 0, left: 0, zIndex: 999 }}
          />
        )}
        {process.env.NODE_ENV !== 'production' && (
          <div style={{ height: '85vh' }} />
        )}
        {modules[properties?.module || 'intro']}
        {process.env.NODE_ENV !== 'production' && (
          <div style={{ height: '85vh' }} />
        )}
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
